// extracted by mini-css-extract-plugin
export default {"jl_alerte":"gw-alert_jl_alerte__zWvT4"};